import React from "react";
import { useTranslation } from "react-i18next";

import { ClassroomSummaryCard } from "adminComponents/molecules/ClassroomSummaryCard";
import {
  ConfirmModal,
  IConfirmModalProps,
} from "adminComponents/molecules/ConfirmModal";
import { IClassroom } from "links/lib/types";

interface IProps {
  accuracy?: number;
  classroom: IClassroom;
  isLoading?: IConfirmModalProps["isLoading"];
  isOpen: IConfirmModalProps["isOpen"];
  handleClose: IConfirmModalProps["handleClose"];
}

export const ClassroomDeleteModal: React.FC<IProps> = ({
  accuracy,
  classroom,
  ...props
}) => {
  const { t } = useTranslation("admin", { useSuspense: false });
  return (
    <ConfirmModal
      {...props}
      buttonCancelLabel={t("classroomDeleteModal.cancelButton")}
      buttonOKLabel={t("classroomDeleteModal.confirmButton")}
      description={t("classroomDeleteModal.description")}
      size="2xl"
      title={t("classroomDeleteModal.title")}
      variant="adminModalCompactMobile"
    >
      <ClassroomSummaryCard accuracy={accuracy} classroom={classroom} />
    </ConfirmModal>
  );
};
